module.exports = __webpack_public_path__ + "img/jdate.88ca525.svg";